module.exports = __webpack_public_path__ + "static/media/toll.ec0d9f14.svg";